import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { OfferState } from './offer.type';

function createInitialState(): OfferState {
  return {
    // Initial data should be null so that it's possible to distinguish between unloaded data and loaded data with no offers
    data: null,
    success: null,
    currOfferId: null,
    accessToken: null,
    currRedeemId: null,
    redeemedOffer: null,
    redeemedOffers: null,
    loaded: null,
    redeemedPromoCodes: null,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'offer', resettable: true })
export class OfferStore extends Store<OfferState> {
  constructor() {
    super(createInitialState());
  }
}
